export default __webpack_public_path__ + "static/media/marilene-vieira-title.bbc731b7.png";